//import css from './css/ActionModal.module.css';

import ConfirmModal from "../ConfirmModal";
import { useState } from "react";
import { toast } from "react-toastify";
import messageFromError from "utils/errorUtils";
import { useTranslation } from "react-i18next";

const ActionModal = ({ func, active, title, children, onCancel, onConfirm, positiveButton, negativeButtonText = null, hideOnConfirm, size = null, validator = null, hideNegativeButton = false }) => {

    const [showSpinner, setShowSpinner] = useState(false)
    const { t } = useTranslation()

    async function execute() {
        if (func) {
            setShowSpinner(true)
            try {
                await func()
            } catch (error) {
                toast.error(messageFromError(error))
            } finally {
                setShowSpinner(false)
            }
        }
        onConfirm();  // always run onConfirm
        if (hideOnConfirm) {
            onCancel();
        }
    }


    if (!hideNegativeButton) {
        if (!negativeButtonText) {
            negativeButtonText = t('global.operations.cancel')
        }
    }
    if (!positiveButton.text) {
        positiveButton.text = t('global.operations.confirm')
    }

    return (
        <ConfirmModal active={active} title={title} children={children} onCancel={onCancel} onConfirm={execute} positiveButton={positiveButton} negativeButtonText={negativeButtonText} showSpinner={showSpinner} size={size} validator={validator} hideNegativeButton={hideNegativeButton}>
            {children}
        </ConfirmModal>
    );
};

ActionModal.defaultProps = {
    active: false,
    onCancel: () => { },
    onConfirm: () => { },
    hideOnConfirm: false,
    positiveButton: {
        variant: 'success'
    },
    hideNegativeButton: false
}

export default ActionModal;